module.exports = __webpack_public_path__ + "static/media/2017_RM_HallofFame_outlines.99a79b2e.png";